export const dateFormat = (date: string, hyphen?: boolean): string => {
  const dateInDate = new Date(date)

  const day = String(dateInDate.getDate()).padStart(2, '0')
  const month = String(dateInDate.getMonth() + 1).padStart(2, '0')
  const year = dateInDate.getFullYear()

  return hyphen ? `${year}-${month}-${day}` : `${day}.${month}.${year}`
}
